var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C3.13359 14 0 10.8664 0 7C0 3.13359 3.13359 0 7 0C10.8664 0 14 3.13359 14 7C14 10.8664 10.8664 14 7 14ZM7 8.75C6.51602 8.75 6.125 9.14102 6.125 9.625C6.125 10.109 6.51602 10.5 7 10.5C7.48398 10.5 7.875 10.109 7.875 9.625C7.875 9.14102 7.48398 8.75 7 8.75ZM7 3.5C6.50234 3.5 6.10586 3.92383 6.14141 4.42148L6.34375 7.26523C6.36836 7.60977 6.65547 7.875 6.99727 7.875C7.3418 7.875 7.62617 7.60977 7.65078 7.26523L7.85313 4.42148C7.88867 3.92383 7.49492 3.5 6.99453 3.5H7Z",
    fill: "#C71900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.935f8ce810077e63fed4b7676590281d.svg";
export { ForwardRef as ReactComponent };